'use client';

import { FC, FormEvent } from 'react';

import GoogleMapEmbed from '@/components/common/google-map-embed/google-map-embed';
import { Button, Input, Textarea } from '@/components/ui';
import { useTranslation } from '@/providers/app-provider/app-provider';

interface ContactProps {
  title: string;
  description: string;
  mapEmbedUrl: string;
}

const Contact: FC<ContactProps> = ({ title, description, mapEmbedUrl }) => {
  const { t } = useTranslation();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  return (
    <div className="container mx-auto px-5 py-16">
      <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">
        <div>
          <h1 className="mb-4 text-4xl font-bold">{title}</h1>
          <p className="mb-8 text-gray-700">{description}</p>

          <form className="mt-6 flex flex-col gap-4" onSubmit={handleSubmit} noValidate>
            <Input
              type="text"
              name="name"
              label={t?.common.contactForm.name}
              placeholder={t?.common.contactForm.namePlaceholder}
              labelPlacement="outside"
              isRequired
              autoComplete="name"
            />

            <Input
              type="email"
              name="email"
              label={t?.common.contactForm.email}
              placeholder={t?.common.contactForm.emailPlaceholder}
              labelPlacement="outside"
              isRequired
              autoComplete="email"
            />

            <Textarea
              name="message"
              label={t?.common.contactForm.message}
              placeholder={t?.common.contactForm.messagePlaceholder}
              labelPlacement="outside"
              isRequired
              minRows={5}
            />

            <Button type="submit" color="primary" className="w-full">
              {t?.common.contactForm.submit}
            </Button>
          </form>
        </div>

        <div className="flex h-full w-full justify-center">
          <GoogleMapEmbed mapEmbedUrl={mapEmbedUrl} className="w-full" />
        </div>
      </div>
    </div>
  );
};

export default Contact;
